var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 27,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#group_svg__a)",
  d: "M26.26 6.07H.26v15.787A4.643 4.643 0 0 0 4.902 26.5h16.716a4.644 4.644 0 0 0 4.643-4.643z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#group_svg__b)",
  d: "M26.261 7.83H.26v14.427c0 1.125.49 2.204 1.36 3S3.671 26.5 4.902 26.5h16.716c1.231 0 2.412-.447 3.283-1.243.87-.796 1.36-1.875 1.36-3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#group_svg__c)",
  d: "M26.26 5.143A4.643 4.643 0 0 0 21.619.5H4.902A4.643 4.643 0 0 0 .259 5.143V7.93H26.26z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "group_svg__a",
  x1: 9.545,
  x2: 16.046,
  y1: 6.07,
  y2: 26.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3E0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8CD0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "group_svg__b",
  x1: 13.26,
  x2: 14.897,
  y1: 15.467,
  y2: 52.546,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0643F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "group_svg__c",
  x1: 12.484,
  x2: 12.685,
  y1: 0.778,
  y2: 22.745,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1B2D49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0643F8"
})))));
export { SvgGroup as ReactComponent };
export default __webpack_public_path__ + "static/media/group.2ad64db3.svg";